export default __webpack_public_path__ + "static/media/ongoingIcon.236f95f5.svg";